<div class="toolbar">
	<div class="toolbar__logo">
		<img *ngIf="!isTitle; else isTitle_" [src]="image" />
		<ng-template #isTitle_>
			<div class="title">
				<h2>{{ title }}</h2>
			</div>
		</ng-template>
	</div>

	<div class="toolbar__actions">
		<div class="toolbar__label">
			<img
				src="./assets/images/icons/authorized.svg"
				alt="whatsapp icon for contact" />
			<p>Autorizado por la <span>CNBV</span></p>
		</div>
		<div class="toolbar__contact">
			<div>
				<img
					src="./assets/images/icons/phone.svg"
					alt="Icono de telefono de Contacto" />
			</div>
			<div>
				<p>Contacto</p>
				<p>Tel. 800 3000 268</p>
			</div>
		</div>
	</div>
	<button *ngIf="isBack" (click)="onClickBack()" class="toolbar__back-button">
		<i class="bi bi-arrow-left"></i>
	</button>
</div>
